<template>
    <msv-row style="margin-top:150px;">
        <msv-column :cols="8" :push="2">
            <mds-alert variation="error" :dismissible="false" title="Something went wrong">
                <template v-slot:default="props">
                    <div v-if="props.text">{{ props.text }}</div>
                    <div v-if="$route.params.error && isDevelopment">
                        <div>{{ $route.params.error.message }}</div>
                        <div>{{ $route.params.error.stack }}</div>
                    </div>
                </template>
            </mds-alert>
        </msv-column>
    </msv-row>
</template>

<script>
import MdsAlert from "@/components/base/Alert";
export default {
    name: "error-page",
    components: {
        MdsAlert
    },
    computed: {
        isDevelopment() {
            return process.env.NODE_ENV === "development";
        }
    }
};
</script>
